import { ViewMode } from '@/visualization/display/types';

const ALL_VIEW_MODES = Object.values(ViewMode);

/** Feature visible only in the listed view modes; hidden in all others. */
export function visibleIn(...modes: ViewMode[]): ReadonlyMap<ViewMode, boolean> {
    const map = new Map<ViewMode, boolean>();
    for (const m of ALL_VIEW_MODES) map.set(m, false);
    for (const m of modes) map.set(m, true);
    return map;
}

/** Feature hidden only in the listed view modes; visible in all others. */
export function hiddenIn(...modes: ViewMode[]): ReadonlyMap<ViewMode, boolean> {
    const map = new Map<ViewMode, boolean>();
    for (const m of ALL_VIEW_MODES) map.set(m, true);
    for (const m of modes) map.set(m, false);
    return map;
}

/** Visible in 3D only; hidden in all 2D/CPR views. */
export const VISIBLE_3D_ONLY = visibleIn(ViewMode.VIEW_3D);

/** Visible in axial, sagittal, and coronal 2D views only; hidden in 3D/CPR. */
export const VISIBLE_2D_ONLY = visibleIn(
    ViewMode.VIEW_2D_AXIAL,
    ViewMode.VIEW_2D_SAGITTAL,
    ViewMode.VIEW_2D_CORONAL
);
